import { Icon as BaseIcon } from "@yandex-int/hr-components/Icon";
import { composeU } from "@bem-react/core";

import { withTrashIcon } from "@yandex-int/hr-components/Icon/_glyph/Trash";
import { withPlusCircleIcon } from "@yandex-int/hr-components/Icon/_glyph/PlusCircle";
import { withDownloadIcon } from "@yandex-int/hr-components/Icon/_glyph/Download";
import { withArrowShortUpIcon } from "@yandex-int/hr-components/Icon/_glyph/ArrowShortUp";
import { withArrowShortDownIcon } from "@yandex-int/hr-components/Icon/_glyph/ArrowShortDown";
import { withMoreVerticalIcon } from "@yandex-int/hr-components/Icon/_glyph/MoreVertical";
import { withEditIcon } from "@yandex-int/hr-components/Icon/_glyph/Edit";
import { withTrashAlternativeIcon } from "@yandex-int/hr-components/Icon/_glyph/TrashAlternative";
import { withCloseIcon } from "@yandex-int/hr-components/Icon/_glyph/Close";
import { withCheckIcon } from "@yandex-int/hr-components/Icon/_glyph/Check";
import { withDayCheckedIcon } from "@yandex-int/hr-components/Icon/_glyph/DayChecked";
import { withDayIcon } from "@yandex-int/hr-components/Icon/_glyph/Day";
import { withProfileIcon } from "@yandex-int/hr-components/Icon/_glyph/Profile";
import { withLogOutIcon } from "@yandex-int/hr-components/Icon/_glyph/LogOut";
import { withTripIcon } from "@yandex-int/hr-components/Icon/_glyph/Trip";
import { withEyeIcon } from "@yandex-int/hr-components/Icon/_glyph/Eye";
import { withSearchIcon } from "@yandex-int/hr-components/Icon/_glyph/Search";
import { withPlusIcon } from "@yandex-int/hr-components/Icon/_glyph/Plus";
import { withFilterAlternativeIcon } from "@yandex-int/hr-components/Icon/_glyph/FilterAlternative";
import { withEyeOffIcon } from "@yandex-int/hr-components/Icon/_glyph/EyeOff";
import { withNotificationsIcon } from "@yandex-int/hr-components/Icon/_glyph/Notifications";
import { withRefreshIcon } from "@yandex-int/hr-components/Icon/_glyph/Refresh";
import { withErrorTriangleIcon } from "@yandex-int/hr-components/Icon/_glyph/ErrorTriangle";
import { withArrowShortLeftIcon } from "@yandex-int/hr-components/Icon/_glyph/ArrowShortLeft";
import { withArrowShortRightIcon } from "@yandex-int/hr-components/Icon/_glyph/ArrowShortRight";
import { withCopyIcon } from "@yandex-int/hr-components/Icon/_glyph/Copy";
import { withSettingsIcon } from "@yandex-int/hr-components/Icon/_glyph/Settings";
import { withInNewTabIcon } from "@yandex-int/hr-components/Icon/_glyph/InNewTab";
import { withArrowLongLeftIcon } from "@yandex-int/hr-components/Icon/_glyph/ArrowLongLeft";
import { withInfoIcon } from "@yandex-int/hr-components/Icon/_glyph/Info";
import { withLockIcon } from "@yandex-int/hr-components/Icon/_glyph/Lock";
import { withFullscreenIcon } from "@yandex-int/hr-components/Icon/_glyph/Fullscreen";
import { withQuestionIcon } from "@yandex-int/hr-components/Icon/_glyph/Question";
import { withStarIcon } from "@yandex-int/hr-components/Icon/_glyph/Star";
import { withLinkIcon } from "@yandex-int/hr-components/Icon/_glyph/Link";
import { withRepeatIcon } from "@yandex-int/hr-components/Icon/_glyph/Repeat";
import { withShareIcon } from "@yandex-int/hr-components/Icon/_glyph/Share";
import { withUploadIcon } from "@yandex-int/hr-components/Icon/_glyph/Upload";
import { withDocumentIcon } from "@yandex-int/hr-components/Icon/_glyph/Document";
import { withCheckCircleIcon } from "@yandex-int/hr-components/Icon/_glyph/CheckCircle";
import { withErrorIcon } from "@yandex-int/hr-components/Icon/_glyph/Error";
import { withCloseCircleIcon } from "@yandex-int/hr-components/Icon/_glyph/CloseCircle";
import { withPlayIcon } from "@yandex-int/hr-components/Icon/_glyph/Play";
import { withBanIcon } from "@yandex-int/hr-components/Icon/_glyph/Ban";
import { withHrIcon } from "@yandex-int/hr-components/Icon/_glyph/Hr";
import { withMailIcon } from "@yandex-int/hr-components/Icon/_glyph/Mail";
import { withGroupIcon } from "@yandex-int/hr-components/Icon/_glyph/Group";
import { withGapTripIcon } from "@yandex-int/hr-components/Icon/_glyph/GapTrip";
import { withGapShieldIcon } from "@yandex-int/hr-components/Icon/_glyph/GapShield";
import { withGapBabyIcon } from "@yandex-int/hr-components/Icon/_glyph/GapBaby";
import { withGapSickIcon } from "@yandex-int/hr-components/Icon/_glyph/GapSick";
import { withGapDayOffIcon } from "@yandex-int/hr-components/Icon/_glyph/GapDayOff";
import { withGapPlaneIcon } from "@yandex-int/hr-components/Icon/_glyph/GapPlane";
import { withGraduationCapIcon } from "@yandex-int/hr-components/Icon/_glyph/GraduationCap";
import { withGapOfficeIcon } from "@yandex-int/hr-components/Icon/_glyph/GapOffice";
import { withGapHomeIcon } from "@yandex-int/hr-components/Icon/_glyph/GapHome";
import { withGapAbsenceIcon } from "@yandex-int/hr-components/Icon/_glyph/GapAbsence";
import { withMenuIcon } from "@yandex-int/hr-components/Icon/_glyph/Menu";
import { withHelpIcon } from "@yandex-int/hr-components/Icon/_glyph/Help";
import { withArrowLongRightIcon } from "@yandex-int/hr-components/Icon/_glyph/ArrowLongRight";

export const Icon = composeU(
    withFullscreenIcon,
    withArrowLongRightIcon,
    withGapTripIcon,
    withMenuIcon,
    withHelpIcon,
    withGapShieldIcon,
    withGapBabyIcon,
    withGraduationCapIcon,
    withGapOfficeIcon,
    withGapHomeIcon,
    withGapAbsenceIcon,
    withGapDayOffIcon,
    withGapPlaneIcon,
    withGapSickIcon,
    withTrashIcon,
    withMailIcon,
    withGroupIcon,
    withHrIcon,
    withRepeatIcon,
    withPlusCircleIcon,
    withDownloadIcon,
    withUploadIcon,
    withShareIcon,
    withArrowShortUpIcon,
    withArrowShortDownIcon,
    withMoreVerticalIcon,
    withEditIcon,
    withBanIcon,
    withPlayIcon,
    withCloseCircleIcon,
    withErrorIcon,
    withDocumentIcon,
    withCheckCircleIcon,
    withTrashAlternativeIcon,
    withCloseIcon,
    withCheckIcon,
    withDayIcon,
    withDayCheckedIcon,
    withLogOutIcon,
    withProfileIcon,
    withTripIcon,
    withLockIcon,
    withEyeIcon,
    withEyeOffIcon,
    withSearchIcon,
    withPlusIcon,
    withFilterAlternativeIcon,
    withNotificationsIcon,
    withRefreshIcon,
    withArrowShortLeftIcon,
    withArrowShortRightIcon,
    withLinkIcon,
    withErrorTriangleIcon,
    withArrowLongLeftIcon,
    withSettingsIcon,
    withInNewTabIcon,
    withCopyIcon,
    withInfoIcon,
    withStarIcon,
    withQuestionIcon,
    withArrowShortUpIcon,
    withArrowShortDownIcon,
)(BaseIcon);
